// extracted by mini-css-extract-plugin
module.exports = {"tag":"tag-list_tag__gUaDh"};